import { useEffect, useState, useCallback } from "react";
import { RequestHelper } from "../../../utils/requestHelper";
import { _ROUTES } from "../../../utils/_routes_constants";
import { getDataGeneric } from "../../../repository/DataGeneric";
import {
  _ACTIONS,
  _HTTP,
  _MESSAGES,
  _SWAL_ICONS,
} from "../../../utils/constants";
import { createToast } from "../../../utils/toast";
import { buildIRI } from "../../../utils/function";
import { DataTable } from "../../ui/DataTable";
import ColumnBuilder from "./ColumnBuilder";
import { formDataToRow } from "./utils";
import _ from "lodash";

const TableInputRateIncrease = ({ params }) => {
  const [activities, setActivities] = useState([]);
  const [columns] = useState(ColumnBuilder());
  const [rows, setRows] = useState([]);
  const rq = new RequestHelper();
  useEffect(() => {
    getDataGeneric(
      rq,
      { active: true, "exists[sites]": 1 },
      (d) => {
        setActivities(d);
      },
      _ROUTES.ACTIVITIES,
      "Unable to retrieve activities",
    );
  }, []);

  useEffect(() => {
    getDataGeneric(
      rq,
      {},
      (d) => {
        const rowData = formDataToRow(d, activities, params);
        setRows(rowData);
      },
      _ROUTES.INPUT_RATE_INCREASE,
      "Unable to retrieve input rate increase rows",
    );
  }, [activities]);

  const handleCellValueChanged = useCallback(
    async (agParams) => {
      const { colDef, data, newValue, node } = agParams;
      const field = colDef.field;
      const month = parseInt(field.replace("months.", ""));

      const payload = {
        pcIncrease: newValue,
        theme: data.theme,
        site: buildIRI("/sites", data.siteId),
        activity: buildIRI("/activities", data.activityId),
        fiscalMonth: month,
        fiscalYear: params.fiscalYear,
        version: params.version || 1,
      };

      const inputRateIncreaseGroupId = data.inputRateIncreaseGroupId;
      if (!_.isUndefined(inputRateIncreaseGroupId[month])) {
        payload.id = inputRateIncreaseGroupId[month];
      }

      const method = payload.id ? _ACTIONS.PATCH : _ACTIONS.POST;
      const url = payload.id
        ? `${_ROUTES.INPUT_RATE_INCREASE}/${payload.id}`
        : _ROUTES.INPUT_RATE_INCREASE;

      rq.doRequest(method, url, payload)
        .then((res) => {
          if (res.status === _HTTP.created || res.status === _HTTP.ok) {
            createToast(_SWAL_ICONS.success, "Rate saved successfully");
            // Update fiscal_month_id_mapping if it's a POST request
            if (method === _ACTIONS.POST && res.data?.id) {
              const updatedData = {
                ...data,
                inputRateIncreaseGroupId: {
                  ...data.inputRateIncreaseGroupId,
                  [month]: res.data.id,
                },
              };
              node.setData(updatedData);
            }
          }
        })
        .catch(() => {
          createToast(_SWAL_ICONS.error, _MESSAGES.error);
        });
    },
    [params, rq],
  );

  return (
    <DataTable
      rows={rows}
      columns={columns}
      onCellValueChanged={handleCellValueChanged}
      fullHeight={true}
      agGridProps={{
        groupDisplayType: "groupRows",
        cellSelection: true,
        getRowStyle: (params) => {
          if (params.data === undefined) {
            return { backgroundColor: "#D3D3D3" };
          }
        },
      }}
    />
  );
};

export default TableInputRateIncrease;
